var _rect, _text, _circle, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscoverlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 38,
    viewBox: "0 0 55 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 38,
    fill: "white"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 2,
    y: 24,
    fontFamily: "Arial Black",
    fontSize: 13,
    fill: "black"
  }, "DISC")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 19,
    r: 3.5,
    fill: "#FF6B1B"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 35,
    y: 24,
    fontFamily: "Arial Black",
    fontSize: 13,
    fill: "black"
  }, "VER")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscoverlogo);
export default __webpack_public_path__ + "static/media/Discoverlogo.b29a373fd3d2c4f65b1ab1d918156741.svg";
export { ForwardRef as ReactComponent };